import * as Types from './CardLayoutComponents';

export const AllowedComponent = Object.values(Types).map(comp => comp.displayName || comp.name);
